import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { useTranslation } from "react-i18next";
import Router from "./Components/Router/Router.js";
import { ToastContainer } from "react-toastify";
import { NavProvider } from "./Context Api/NavContext.js";
import { AuthProvider } from "./Context Api/AuthContext.js";
import { PermissionProvider } from "./Context Api/PermissionContext.js";

const App = () => {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    const savedLang = localStorage.getItem("language");
    if (!savedLang) {
      i18n.changeLanguage("bn");
      localStorage.setItem("language", "bn");
    } else {
      i18n.changeLanguage(savedLang);
    }
  }, [i18n]);

  // Apply class whenever language changes
  React.useEffect(() => {
    document.body.className = i18n.language === "bn" ? "bangla" : "";
  }, [i18n.language]);

  return (
    <NavProvider>
      <AuthProvider>
        <PermissionProvider>
          <Router />
          <ToastContainer />
        </PermissionProvider>
      </AuthProvider>
    </NavProvider>
  );
};

export default App;
